<template>
    <div class="expense-form">
    <h1>Actualizacion de tablas</h1>
    <div >
    <form>
        <img src="@/assets/logo.png" alt="Logo" class="form-logo">
        <div class="form-group form-container">
            
                <label for="name">Tabla</label>
                <v-select label="name" :options="options" v-model="selectedoption"/>

                <file-pond name="file" :files="myFiles" label-idle="Examina para seleccionar archivo" allow-multiple="false" accepted-file-types="	application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" allowDrop="true" allowReplace @updatefiles="handleUpdateFiles">Subir archivo</file-pond>
                <button type="button" class="btn btn-primary" @click="uploadFile">Actualizar</button>
                <h3 v-if="cargando">Cargando...</h3>
        </div>
    </form>
    </div>
</div>
</template>

<script>
// Import plugins
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

// Import styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import "filepond-plugin-pdf-preview/dist/filepond-plugin-pdf-preview.min.css";
//import imageCompression from 'browser-image-compression';

// Create FilePond component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileValidateSize);

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import {updateProviders} from '@/api/api.js';

export default {
    components: {
        vSelect,
        FilePond,
    },
    name: "UpdateTables",
    data() {
        return {
            updatedData: null,
            options: [
                { name: "Proveedores", value: "pro" },/*
                { name: "Conceptos", value: "con" },
                { name: "Usuarios", value: "usu" },
                { name: "Tipos de Gastos", value: "tdg" },
                { name: "Monedas", value: "mon" },
                { name: "Clientes", value: "cli" },
                { name: "Medios de Transporte", value: "mdt" },
                { name: "Medios de pago", value: "mdp" },*/
            ],
            selectedoption: { name: "Proveedores", value: "pro" },
            myFiles: [],
            cargando: false,
        };
    },
    methods: {
        async uploadFile() {
            this.cargando = true;
            if (!this.selectedoption) {
                alert("Por favor selecciona una tabla para actualizar.");
                return;
             }
            
            const file = this.myFiles[0];
            const formData = new FormData();
            console.log("file", file);
            formData.append("file", file);

            try {
                console.log("formData", formData);
                const response = await updateProviders(formData, this.selectedoption);
                alert("Tabla actualizada correctamente.\nCantidad de filas afectadas: " + response.data);
                
            } catch (error) {
                console.error(error);
            } finally {
                this.cargando = false;
            }
        },
        handleUpdateFiles(fileItems) {
            this.myFiles = fileItems.map(fileItem => fileItem.file);
        }
    },
};
</script>
